module.exports = __webpack_public_path__ + "img/programme3.ebb066f5.png";